import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./general-pages/general-pages.module').then( m => m.GenralPagesModule),
    title: 'Assisted Inspection PWA | Verify OTP'
  },
  {
    path: 'user-panel',
    loadChildren: () => import('./user-panel/user-panel.module').then( m => m.UserPanelModule),
    title: 'Assisted Inspection PWA | Verify OTP'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
